import React, { useState } from 'react';
import '../assets/style.css';
import 'tailwindcss/tailwind.css';
import FullScreenImage from './FullScreenImage';

// Import your images
import panicYoungFinal from '../assets/images/APPAREL/PANIC WWWY/panic when we were young.webp';

import mcrprocessSketch from '../assets/images/BLACK PARADE/mcrbp-process-sketch.webp';
import panicprocess1 from '../assets/images/APPAREL/PANIC WWWY/panic-process-1.webp';
import panicprocess2 from '../assets/images/APPAREL/PANIC WWWY/panic-process-2.webp';
import panicprocess3 from '../assets/images/APPAREL/PANIC WWWY/panic-process-3.webp';
import panicprocess4 from '../assets/images/APPAREL/PANIC WWWY/panic-process-4.webp';
import panicprocess5 from '../assets/images/APPAREL/PANIC WWWY/panic-process-5.webp';
import panicprocess6 from '../assets/images/APPAREL/PANIC WWWY/panic-process-6.webp';
import panicprocess7 from '../assets/images/APPAREL/PANIC WWWY/panic-process-7.webp';
import panicprocess8 from '../assets/images/APPAREL/PANIC WWWY/panic-process-8.webp';
import panicprocess9 from '../assets/images/APPAREL/PANIC WWWY/panic-process-9.webp';

import panicStickers from '../assets/images/APPAREL/PANIC WWWY/panicStickersWWWY.webp';
import panicSelfie from '../assets/images/APPAREL/PANIC WWWY/panicSelfie.webp';
import panicShirt from '../assets/images/APPAREL/PANIC WWWY/panic-shirt.webp';



const PanicinVegas = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (src) => {
    setFullScreenImage(src);
  };

  const handleCloseFullScreen = () => {
    setFullScreenImage(null);
  };

  // Store images in an array
  const images = [panicYoungFinal, mcrprocessSketch, panicprocess1, panicprocess2, 
    panicprocess3, panicprocess4, panicprocess5, panicprocess6, panicprocess7, panicprocess8, 
    panicprocess9, panicStickers, panicSelfie, panicShirt];

  const handlePrevImage = () => {
    if (!fullScreenImage) return;
    const currentIndex = images.indexOf(fullScreenImage);
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setFullScreenImage(images[prevIndex]);
  };

  const handleNextImage = () => {
    if (!fullScreenImage) return;
    const currentIndex = images.indexOf(fullScreenImage);
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % images.length;
    setFullScreenImage(images[nextIndex]);
  };

  return (
    <div>
      {/* Navigation header info bar */}
   

      <div className="columns-1 p-3 md:p-10 m-5 md:m-10">
        <h1 className="text-center" style={{ fontFamily: 'Bebas Neue', color: '#6ac9cb', fontSize: '48px' }}>
          Panic! at When We Were Young
        </h1>
        <p className="text-left text-gray-600 mx-2 sm:mx-20 md:mx-20 lg:mx-28 xl:mx-56 2xl:mx-72 mb-6 leading-relaxed">
          For this project, I wanted to create an illustration to wear for a tour date. I wanted to make 
          something that didn't really exist much anywhere else, and I really enjoy drawing skeletons 
          and creating concept art, so this is the direction I went with. I like the tarot card look, 
          and pulled together something that's fun, my style, and unique.

         
      <br></br>
         <br></br>
          I started by sketching and brainstorming different elements to include, and settled 
          on a color palette that was inspired by muted tones of burgundy, gold, orange, and black. 
          From there, I drew out different elements in Photoshop, and created the composition. 
          
         I wanted an illustration that was emo, energetic, professional and unique to my 
         style that engages the audience. 
        </p>
        
        <p className="text-left text-gray-600 mx-2 sm:mx-20 md:mx-20 lg:mx-28 xl:mx-56 2xl:mx-72 mb-6 leading-relaxed mt-2">
This artwork captures the dramatic energy and theatrical essence of Panic! At The Disco. Using bold 
compositions, dynamic color contrasts, and intricate line work, the piece brings the band’s music 
and stage persona to life. Each element, from typography to illustrative details, was carefully designed 
to bring out emotion, storytelling, and the band’s signature flair, blending contemporary design with classic 
rock-inspired aesthetics.
            </p>

        {/* Panic Image Display */}
        <img
  src={panicYoungFinal}
  className="mx-auto w-full sm:w-[500px] md:w-[700px] lg:w-[500px] h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicYoungFinal, 0)}
  alt="panic at the disco artwork"
/>



            <h2 className="text-2xl ml-4 sm:text-3xl md:text-2xl sm:ml-8 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 mb-4 mt-8 text-left">
       Illustration process </h2>

          <p className="text-left text-gray-600 mx-2 sm:mx-8 md:mx-8 lg:mx-20 xl:mx-32 2xl:mx-72 mb-6 leading-relaxed">
        Here's some of my work process. It includes design research such as sketching, the final color 
        palette, different iterations, close-ups of different collage pieces as I built the piece, as 
        well as the final product. It's one of my favorite designs to date and a lot of fun, I love 
        incorporating subtle imagery from the band into my work without overpowering the design. </p>

        

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72">

  <img
    src={panicprocess1}
    className="max-w-[400px] w-full h-[500px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicprocess1, 0)}
    alt="panic sketches"
  />
  <img
    src={panicprocess2}
    className="max-w-[400px] w-full h-[500px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicprocess2, 0)}
    alt="panic sketches"
  />


  <img
    src={panicprocess3}
    className="max-w-[400px] w-full h-[500px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicprocess3, 0)}
    alt="panic sketches"
  />
</div>


<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={panicprocess4}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess4, 0)}
  alt="black parade art"
/>
<img
  src={panicprocess5}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess5, 0)}
  alt="panic sketches"
/>


<img
  src={panicprocess6}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess6, 0)}
  alt="panic sketches"
/>
</div>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 2xl:px-72 mt-7">

<img
  src={panicprocess7}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess7, 0)}
  alt="panic sketches"
/>
<img
  src={panicprocess8}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess8, 0)}
  alt="panic sketches"
/>


<img
  src={panicprocess9}
  className="max-w-[400px] w-full h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicprocess9, 0)}
  alt="panic sketches"
/>
</div>




        <div className="flex flex-col items-center md:flex-row md:justify-center md:gap-4"> 
        

          {/* Second Column (paramoreWork and paramoreWork2 side by side) */}
{/* Second Column (paramoreWork, paramoreWork2, paramoreShirtPrint, paramoreShirt) */}
<div className="flex flex-col sm:flex-row justify-center gap-4 mb-8 md:w-1/2">
 


</div>

         
        </div>

        <img
  src={panicYoungFinal}
  className="mx-auto w-full sm:w-[500px] md:w-[700px] lg:w-[500px] h-auto object-cover rounded shadow-md cursor-pointer"
  onClick={() => handleImageClick(panicYoungFinal, 0)}
  alt="panic at the disco when we were young final artwork design"
/>


        <p className="mb-3 text-center text-gray-600 mb-10 mt-2">
This is the final artwork that went to print.
</p>

<h2 className="text-2xl sm:text-3xl md:text-2xl sm:ml-20 md:ml-12 lg:ml-24 xl:ml-32 2xl:ml-72 font-bold text-gray-800 pb-0 mt-8 text-left">
       Spotted: Out in the Wild </h2>
       <div className="flex flex-col md:flex-row md:justify-start gap-3 mx-2 sm:mx-36 md:-mx-16 md:ml-12 md:mr-80 lg:-mx-4  xl:pl-16 xl:pr-16 2xl:mx-60 mb-2 mt-8">
  <img
    src={panicStickers}
    className="w-full md:w-1/2 max-w-[400px] h-[400px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicStickers, 0)}
    alt="panic stickers for when we were young"
  />

  <img
    src={panicSelfie}
    className="w-full md:w-1/2 max-w-[400px] h-[400px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicSelfie, 0)}
    alt="panic selfie for when we were young with the shirt drawing"
  />

  <img
    src={panicShirt}
    className="w-full md:w-1/2 max-w-[400px] h-[400px] object-cover rounded shadow-md cursor-pointer"
    onClick={() => handleImageClick(panicShirt, 0)}
    alt="panic shirt for when we were young"
  />
</div>


<p className="mb-3 text-left text-gray-600 mb-10 mt-0 mx-2 sm:mx-20 md:mx-10 lg:mx-20 xl:mx-32 2xl:mx-72">
    These were other stickers I designed for the music festival to hand out that were really popular,
  and I included a photo of me wearing the shirt design as well at the show.
</p>




     
      </div>

      {/* Full-screen image modal */}
      {fullScreenImage && (
        <FullScreenImage
          src={fullScreenImage}
          onClose={handleCloseFullScreen}
          onPrev={handlePrevImage}
          onNext={handleNextImage}
        />
      )}
    </div>
  );
};

export default PanicinVegas;
